export const ROUTE_MAP = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  DASHBOARD: '/dashboard',
  BOOKINGS_REPORT: '/bookings-report',
  CALL_CENTER: '/call-center',
};
